import { api } from '@/api';
import { queryOptions } from '@tanstack/react-query';
import { getQueryKeysFactory } from './queryKeysFactory';

export const getScheduleRotationByIdQuery = (params: {
  organizationId: string;
  scheduleId: string;
  rotationId: string;
}) => {
  const { organizationKeys } = getQueryKeysFactory();

  return queryOptions({
    queryKey: organizationKeys.scheduleRotationById(
      params.organizationId,
      params.scheduleId,
      params.rotationId
    ),
    queryFn: async () => {
      const response = await api.GetScheduleRotationById({
        organizationId: params.organizationId,
        scheduleId: params.scheduleId,
        rotationId: params.rotationId,
      });

      return response.data.rotation;
    },
    enabled:
      !!params.organizationId && !!params.scheduleId && !!params.rotationId,
  });
};
